import { Icon } from '@vibe/core';
import { Workspace, Pin, Table, Embed, Link, Person, WrapText, Counter } from '@vibe/icons';
import { type CoreSectionTypes } from '@gorilla/portal-shared/src/core-sections';
import { type Section as SectionType } from '@gorilla/portal-shared/src/schemas';

type SectionMeta = {
  icon: React.FC<any>;
  isOpenByDefault: ((section: SectionType) => boolean) | boolean;
};

export const SECTION_TYPE_TO_META: Record<CoreSectionTypes, SectionMeta> = {
  text: {
    icon: WrapText,
    isOpenByDefault: true,
  },
  embed: {
    icon: Embed,
    isOpenByDefault: true,
  },
  'item-table': {
    icon: Table,
    isOpenByDefault: (section: SectionType) => !section.fieldValues?.['board-source'],
  },
  'item-grid': {
    icon: Workspace,
    isOpenByDefault: (section: SectionType) => !section.fieldValues?.['board-source'],
  },
  callout: {
    icon: Pin,
    isOpenByDefault: true,
  },
  'client-item-summary': {
    icon: Person,
    isOpenByDefault: false,
  },
  teasers: {
    icon: Link,
    isOpenByDefault: true,
  },
  'key-figures': {
    icon: Counter,
    isOpenByDefault: true,
  },
};

export function isSectionOpenByDefault(section: SectionType): boolean {
  // @ts-ignore
  const meta = SECTION_TYPE_TO_META[section.type];
  if (!meta) {
    return true;
  }

  return typeof meta.isOpenByDefault === 'function' ? meta.isOpenByDefault(section) : meta.isOpenByDefault;
}

type SectionIconProps = {
  sectionType: CoreSectionTypes;
};

export function SectionIcon({ sectionType }: SectionIconProps) {
  const SectionIconComponent = SECTION_TYPE_TO_META[sectionType].icon;
  return <Icon icon={SectionIconComponent} size={22} style={{ minWidth: '22px' }} />;
}
